import React, { FC } from 'react'

import { ColorChoices } from 'src/theme/colors'
import { SmallOrLarge } from 'src/app/types'
import { FormattedPrice } from 'src/marketing/plans/components'

import styles from './styles'

type SubscriptionPriceProps = {
  dollars: string | number
  cents: string | number
  per: string
  amountColor?: ColorChoices
  perColor?: ColorChoices
  size?: SmallOrLarge
}

const SubscriptionPrice: FC<SubscriptionPriceProps> = props => {
  const {
    dollars,
    cents,
    per,
    perColor = 'pink',
    amountColor = 'pink',
    size = 'large',
  } = props
  return (
    <div css={styles.wrapper}>
      <FormattedPrice
        dollars={dollars}
        cents={cents}
        color={amountColor}
        size={size}
      />
      <div
        css={theme => styles.per(theme, theme.colors[perColor])}
      >{`/ ${per}`}</div>
    </div>
  )
}

export default SubscriptionPrice
